// extracted by mini-css-extract-plugin
export default {"Layout":"Layout___E8giK","Header":"Header___wIyki","layoutNoHeader":"layoutNoHeader___U6c5V"};